// removed by extract-text-webpack-plugin
module.exports = {"verificationRemainderModal":"qempo_VerificationRemainderModal_verificationRemainderModal-2IsqAMA","modalLoading":"qempo_VerificationRemainderModal_modalLoading-2eze5Pv"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/auth/auth-modals/verification-remainder-modal/component/VerificationRemainderModal.scss
// module id = 1977
// module chunks = 0